var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c(_vm.vista_a_abrir,{tag:"component",on:{"close":function($event){return _vm.$emit('close')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }